(($) => {
  $(document).ready(() => {
    const hasCareersGalleryBlock = document.querySelectorAll('.careers-gallery');
    if (!hasCareersGalleryBlock.length === 0) {
      return null;
    }

    const wrapperPopup = document.querySelector(".careers-gallery-popup");
    const popup = document.querySelector(".careers-gallery-popup .popup");
    const buttons = document.querySelectorAll(".careers-gallery button");
    const closeButton = document.querySelector(".careers-gallery-popup button");

    // this one is obvious
    closeButton.addEventListener("click", () => {
      wrapperPopup.classList.remove("show");
    });

    // close if the esc key is pressed
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        wrapperPopup.classList.remove("show");
      }
    });

    // listen to clicks outside the visible popup
    document.addEventListener("click", (e) => {
      const isClickInside = popup.contains(e.target);
      const isButton = e.target.closest(".careers-gallery button");
      if (!isClickInside && !isButton) {
        wrapperPopup.classList.remove("show");
      }
    });

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        popup.querySelector(
          ".content"
        ).innerHTML = `<img src="${button.dataset.image}">`;
        wrapperPopup.classList.add("show");
      });
    });
  });
})(jQuery);
